/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillOverridesControllerFindAllQueryResponse, SkillOverridesControllerFindAll401, SkillOverridesControllerFindAll403 } from "../../models/skillOverridesController/SkillOverridesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { skillOverridesControllerFindAll } from "../../clients/skill-overridesService/skillOverridesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const skillOverridesControllerFindAllQueryKey = () => [{
  url: '/api/v1/skill-overrides'
}] as const;
export type SkillOverridesControllerFindAllQueryKey = ReturnType<typeof skillOverridesControllerFindAllQueryKey>;
export function skillOverridesControllerFindAllQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = skillOverridesControllerFindAllQueryKey();
  return queryOptions<SkillOverridesControllerFindAllQueryResponse, ResponseErrorConfig<SkillOverridesControllerFindAll401 | SkillOverridesControllerFindAll403>, SkillOverridesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return skillOverridesControllerFindAll(config);
    }
  });
}

/**
 * @summary List visible skill overrides
 * {@link /api/v1/skill-overrides}
 */
export function useSkillOverridesControllerFindAll<TData = SkillOverridesControllerFindAllQueryResponse, TQueryData = SkillOverridesControllerFindAllQueryResponse, TQueryKey extends QueryKey = SkillOverridesControllerFindAllQueryKey>(options: {
  query?: Partial<QueryObserverOptions<SkillOverridesControllerFindAllQueryResponse, ResponseErrorConfig<SkillOverridesControllerFindAll401 | SkillOverridesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? skillOverridesControllerFindAllQueryKey();
  const query = useQuery({
    ...skillOverridesControllerFindAllQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SkillOverridesControllerFindAll401 | SkillOverridesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}